<template>
    <div>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="用户名:">
                    <el-input v-model="form.keyword" @keyup.enter.native="loadData" class="common-input"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="loadData">搜索</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/thirdPartyUserAdd',query: { callback:request } }">
                    <el-button type="primary" >新增</el-button>
                    <!--v-w-role="'ITSM-0079'"-->
                </router-link>

            </div>
            <el-table :data="tableData" v-loading="loading">

                <el-table-column label="用户名" prop="userid" ></el-table-column>
                <el-table-column label="中文名" prop="name"></el-table-column>
                <el-table-column label="手机号" prop="mobile"></el-table-column>
                <el-table-column label="邮箱" prop="email" min-width="120px"></el-table-column>
                <el-table-column label="性别" prop="gender">
                    <template slot-scope="scope">
                        {{scope.row.gender | tableVal(genderStatus)}}
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        {{ scope.row.enable | tableVal(userStatus) }}
                    </template>
                </el-table-column>
                <!--<el-table-column label="中文名" prop="cname"></el-table-column>-->
                <el-table-column label="工号" prop="employeeNo"></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/thirdPartyUserAdd',
                                        query: { type:'edit',userid:scope.row.userid,callback:request }}">
                            <el-button type="text" >编辑</el-button>
                        </router-link>
                        <el-button v-w-role="'ITSM-0045'" class="table-del-btn" type="text" @click="deleteRole(scope.row.userid)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    // import { statusLists } from "./event.config";
    import services from "./system.service";
    import commonService from "../../services/common.service";
    export default {
        data() {
            return {
                form:{
                    keyword:'',
                    pageSize:10,
                    pageIndex:1,
                },
                total:null,
                tableData:[],
                loading:false,
                // statusLists,
                ExportBtn:false,
                userStatus:[
                    {id:0,cname:'停用'},
                    {id:1,cname:'启用'},
                ],
                genderStatus:[
                    {id:2,cname:'女'},
                    {id:1,cname:'男'},
                ],

            }
        },
        created() {
            this.request();
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },


        },
        methods: {

            loadData(){
                this.form.pageIndex = 1;
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                this.request();
            },
            request(){
                // 获取列表数据
                services.getThirdPartyUserList(this.form).then(res => {
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            deleteRole(val){
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.deleteThirdPartyUser({ userid:val }).then(res => {
                        this.$message.success("删除成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
